const elementID = {
  headerNavbar: "header-navbar",
};

export default elementID;
